import { Breadcrumb, Button } from "antd";
import Loading from "../../../../auxiliary/loader/loading";
import OprationResult from "../../../../auxiliary/opration/opration";
import { _adr } from "../../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useDealer } from "../../../../../tools/api";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { convertToJalaliWithoutTime } from "../../../../../tools/tools";
import { Content } from "antd/es/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import Profile from "../../profile/profile";
import { clearFormData } from "../../../../../reducer/serviceReducer";

const CoSimFinal = () => {
	const [t] = useTranslation("global");
	const formData = useSelector((state) => state?.from?.swchange);
	const dispatch = useDispatch();
	const { simSwap } = useDealer();

	const [final, setFinal] = useState({
		isLoading: true,
		isSuccess: -1,
		isActive: false,
		resultRes: null,
		purchase: formData?.purchase,
	});

	useEffect(() => {
		const swapSimcardFinal = async () => {
			let payload = {
				msisdn: formData?.purchase?.inT_MSISDN,
				newiccid: formData?.newKit,
				simswapreason: 2,
				swapnationalid: null,
				swapdocumentid: null,
				planid:process.env.REACT_APP_PLANID_CHANGE_SIMCARD
			};
			let response = await simSwap(payload);
			if (response) {
				setFinal((final) => ({ ...final, isActive: true, isSuccess: true, resultRes: response }));
				dispatch(clearFormData(["swchange"]));
			} else {
				setFinal((final) => ({ ...final, isActive: true, isSuccess: false }));
			}
			setFinal((final) => ({ ...final, isLoading: false }));
		};
		swapSimcardFinal();
	}, []);

	return (
		<>
			<div className="container-main container-sp">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.legal.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardreplacement.legal.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<Profile Profile={final?.purchase} state />
							<div className="g-body-format-page">
								{final?.isActive &&
									(final?.isSuccess ? (
										<OprationResult
											isSucess={final?.isSuccess}
											list={[
												{
													label: "تاریخ و ساعت",
													value: (
														<>
															{/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
															<span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
														</>
													),
												},
												{
													label: "نوع سرویس",
													value: final?.resultRes?.serviceType,
												},
												{
													label: "شماره سیم کارت",
													value: final?.resultRes?.msisdn,
												},
												{
													label: "شماره کیت جدید",
													value: final?.resultRes?.iccIdNew,
												},
												{
													label: "کد پیگیری",
													value: final?.resultRes?.strFollwUpCode,
												},
											]}
										/>
									) : (
										<OprationResult
											isSucess={final?.isSuccess}
											list={[
												{
													label: "تاریخ و ساعت",
													value: (
														<>
															{/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
															<span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
														</>
													),
												},
											]}
										/>
									))}
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										className="btn-normal btn-print"
										onClick={() => {
											window.print();
										}}
										type="default"
										icon={<i className="icon-print"></i>}>
										چاپ رسید
									</Button>
								</div>
							</div>
						</div>
					</Content>
					<Loading isOpen={final?.isLoading} />
				</div>
			</div>
		</>
	);
};

export default CoSimFinal;
